import { useState } from "react";
import { hotComments } from "@/mocks/blackMaterial";

const toneAvatar: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-200 text-foreground-700",
};

export default function CommentSection() {
  const [text, setText] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSent(true);
    setText("");
    window.setTimeout(() => setSent(false), 2600);
  };

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-16 md:px-6 md:py-24">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_1.4fr] lg:gap-16">
          <div className="flex flex-col gap-5 lg:sticky lg:top-24 lg:self-start">
            <span className="text-xs font-semibold tracking-[0.18em] text-primary-500">评论区见真章</span>
            <h2 className="text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
              榜单一出来，
              <br />
              评论区先替你吵完了。
            </h2>
            <p className="text-sm leading-7 text-foreground-500">
              考古、对线、神补刀，围观本身就是黑料盘点最热闹的一环。热评会被顶到前排，理性讨论会被置顶加精。
            </p>

            <form onSubmit={handleSubmit} className="mt-2 flex flex-col gap-3 rounded-lg border border-background-200 bg-background-100/60 p-4">
              <textarea
                value={text}
                onChange={(e) => setText(e.target.value.slice(0, 200))}
                rows={3}
                placeholder="一句话加入围观（演示环境，不会真实提交）…"
                className="w-full resize-none rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-sm outline-none placeholder:text-foreground-400 focus:border-primary-300"
              />
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">{text.length}/200</span>
                <button
                  type="submit"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                >
                  <i className="ri-send-plane-line text-base" />
                  发布围观
                </button>
              </div>
              {sent && (
                <div className="rounded-md bg-accent-100 px-3 py-2 text-xs text-accent-800">
                  <i className="ri-checkbox-circle-fill mr-1" />
                  已记录你的围观（演示，无真实提交）
                </div>
              )}
              <div className="hp-field" aria-hidden="true">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" readOnly />
              </div>
            </form>
          </div>

          <div className="flex flex-col gap-3">
            {hotComments.map((c) => (
              <div
                key={c.name}
                className="group flex cursor-pointer flex-col gap-3 rounded-lg border border-background-200 bg-background-100/50 p-5 transition-colors hover:border-background-300"
              >
                <div className="flex items-center gap-3">
                  <span className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold ${toneAvatar[c.tone]}`}>
                    {c.name.slice(0, 1)}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-900">{c.name}</span>
                      {c.hot && (
                        <span className="inline-flex items-center gap-0.5 rounded-full bg-accent-500 px-2 py-0.5 text-[10px] font-semibold text-background-50">
                          <i className="ri-fire-fill text-[9px]" />
                          热评
                        </span>
                      )}
                    </div>
                    <div className="text-[11px] text-foreground-400">{c.meta}</div>
                  </div>
                  <span className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-thumb-up-line transition-colors group-hover:text-primary-500" />
                    {c.likes}
                  </span>
                </div>
                <p className="text-sm leading-6 text-foreground-700">{c.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}